/**
 * @flow
 * @relayHash a852fbd42e221c91880246107ee189fd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TwoFactor_viewer$ref = any;
export type TwoFactorQueryVariables = {||};
export type TwoFactorQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: TwoFactor_viewer$ref
  |}
|};
export type TwoFactorQuery = {|
  variables: TwoFactorQueryVariables,
  response: TwoFactorQueryResponse,
|};
*/


/*
query TwoFactorQuery {
  viewer {
    ...TwoFactor_viewer
    id
  }
}

fragment TwoFactor_viewer on Viewer {
  ...TwoFactorConfigure_viewer
  ...TwoFactorDelete_viewer
  permissions {
    totpConfigure {
      allowed
      code
      message
    }
  }
  totp {
    ...RecoveryCodes_totp
    id
    recoveryCodes {
      ...RecoveryCodeList_recoveryCodes
      codes {
        code
        consumed
      }
      id
    }
  }
}

fragment TwoFactorConfigure_viewer on Viewer {
  id
  totp {
    id
    recoveryCodes {
      ...TwoFactorConfigureRecoveryCodes_recoveryCodes
      id
    }
  }
}

fragment TwoFactorDelete_viewer on Viewer {
  totp {
    id
  }
}

fragment RecoveryCodes_totp on TOTP {
  id
  recoveryCodes {
    id
    ...RecoveryCodeList_recoveryCodes
    codes {
      code
      consumed
    }
  }
}

fragment RecoveryCodeList_recoveryCodes on RecoveryCodeBatch {
  codes {
    code
    consumed
  }
}

fragment TwoFactorConfigureRecoveryCodes_recoveryCodes on RecoveryCodeBatch {
  ...RecoveryCodeList_recoveryCodes
  codes {
    code
    consumed
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "TwoFactorQuery",
  "id": null,
  "text": "query TwoFactorQuery {\n  viewer {\n    ...TwoFactor_viewer\n    id\n  }\n}\n\nfragment TwoFactor_viewer on Viewer {\n  ...TwoFactorConfigure_viewer\n  ...TwoFactorDelete_viewer\n  permissions {\n    totpConfigure {\n      allowed\n      code\n      message\n    }\n  }\n  totp {\n    ...RecoveryCodes_totp\n    id\n    recoveryCodes {\n      ...RecoveryCodeList_recoveryCodes\n      codes {\n        code\n        consumed\n      }\n      id\n    }\n  }\n}\n\nfragment TwoFactorConfigure_viewer on Viewer {\n  id\n  totp {\n    id\n    recoveryCodes {\n      ...TwoFactorConfigureRecoveryCodes_recoveryCodes\n      id\n    }\n  }\n}\n\nfragment TwoFactorDelete_viewer on Viewer {\n  totp {\n    id\n  }\n}\n\nfragment RecoveryCodes_totp on TOTP {\n  id\n  recoveryCodes {\n    id\n    ...RecoveryCodeList_recoveryCodes\n    codes {\n      code\n      consumed\n    }\n  }\n}\n\nfragment RecoveryCodeList_recoveryCodes on RecoveryCodeBatch {\n  codes {\n    code\n    consumed\n  }\n}\n\nfragment TwoFactorConfigureRecoveryCodes_recoveryCodes on RecoveryCodeBatch {\n  ...RecoveryCodeList_recoveryCodes\n  codes {\n    code\n    consumed\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TwoFactorQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TwoFactor_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TwoFactorQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v0,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "totp",
            "storageKey": null,
            "args": null,
            "concreteType": "TOTP",
            "plural": false,
            "selections": [
              v0,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "recoveryCodes",
                "storageKey": null,
                "args": null,
                "concreteType": "RecoveryCodeBatch",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "codes",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RecoveryCode",
                    "plural": true,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "consumed",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  v0
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "permissions",
            "storageKey": null,
            "args": null,
            "concreteType": "ViewerPermissions",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "totpConfigure",
                "storageKey": null,
                "args": null,
                "concreteType": "Permission",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "allowed",
                    "args": null,
                    "storageKey": null
                  },
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "message",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7022faffb80748a7d7abb95c1741ca58';
module.exports = node;
